<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid card pt-2 pb-3 justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold mt-2">
                  Customer List
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-2">
              <div class=""></div>
            </div>
            <div class="col-12 md:col-5 lg:col-4">
              <div class="">
                <span class="p-input-icon-left w-full">
                  <i class="pi pi-search" />
                  <InputText outlined dense placeholder="Search" class="w-full" :value="searchText" @input="
                    debounce(() => {
                      searchText = $event.target.value;
                    })
                    " />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section>
      <div class="grid">
        <!-- <div class="col-4 mb:col-12 mb-1">
          <div class="surface-100 p-3 font-bold text-md">
            Filter by Transaction Date
          </div>
          <div class="p-2">
            <Calendar :showIcon="true" :manualInput="false" :showButtonBar="false" dateFormat="yy-mm-dd" hourFormat="24"
              class="w-full" selectionMode="range" v-model="filters.date_created.value" placeholder="Select date"
              :inline="false" />
          </div>
        </div> -->
        <div class="col-4 mb:col-12 mb-1">
          <div class="surface-100 p-3 font-bold text-md">
            Filter by Customer Status
          </div>
          <div class="p-2">
              <Dropdown class="w-full" v-model="filters.customer_status.value" optionLabel="label"
                optionValue="value" :options="app.menus.customerStatus" placeholder="Filter by  customer status ...">
              </Dropdown>
            </div>

        </div>
        <div class="col-4 mb:col-12 mb-1">
          <div class="surface-100 p-3 font-bold text-md">
            Filter by Region
          </div>
          <div class="p-2">
              <Dropdown class="w-full" v-model="filters.region.value" optionLabel="label"
                optionValue="value" :options="app.menus.gwclRegionItems" placeholder="Filter by  region ...">
              </Dropdown>
            </div>

        </div>
        <div v-if="filters.region.value" class="col-4 mb:col-12 mb-1">
          <div class="surface-100 p-3 font-bold text-md">
            Filter by District
          </div>
          <api-data-source @loaded="filters.district.value = ''" :load-on-mount="true" :api-path="`components_data/district_option_list?lookup_region=${filters.region.value}`" v-slot="req" class="">
            <div class="p-2">
              <Dropdown class="w-full" v-model="filters.district.value" :loading="req.loading" optionLabel="label"
                optionValue="value" :options="req.response" placeholder="Filter by district ...">
              </Dropdown>
            </div>
          </api-data-source>

        </div>
      </div>

    </section>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="flex align-items-center justify-content-around">
                <div v-if="searchText" :class="filterTagClass">
                  <Breadcrumb :home="{
                    icon: 'pi pi-times text-lg mr-3',
                    label: 'Search',
                  }" :model="[
                    {
                      label: `${searchText}`,
                    },
                  ]">
                    <template #item="{ item }">
                      <div class="cursor-pointer" :class="item.icon" @click="() => {
                        clearSearch();
                      }
                        "></div>
                      <a :href="item.url">{{ item.label }}</a>
                    </template>
                  </Breadcrumb>
                </div>
                <!-- <div v-if="filterHasValue(filters.date_created)" :class="filterTagClass">
                  <span class="text-primary"> Transaction Date</span>
                  <Chip class="font-medium ml-2 px-3 py-1" removable @remove="removeFilter(filters.date_created)">
                    {{ getFilterLabel(filters.date_created) }}
                  </Chip>
                </div> -->
                <div v-if="filterHasValue(filters.customer_status)" :class="filterTagClass">
                  <span class="text-primary"> Customer Status</span>
                  <Chip class="font-medium ml-2 px-3 py-1" removable @remove="removeFilter(filters.customer_status)">
                    {{ getFilterLabel(filters.customer_status) }}
                  </Chip>
                </div>
                <div v-if="filterHasValue(filters.region)" :class="filterTagClass">
                  <span class="text-primary"> Region</span>
                  <Chip class="font-medium ml-2 px-3 py-1" removable @remove="removeFilter(filters.region); removeFilter(filters.district)">
                    {{ getFilterLabel(filters.region) }}
                  </Chip>
                </div>
                <div v-if="filterHasValue(filters.district)" :class="filterTagClass">
                  <span class="text-primary"> District</span>
                  <Chip class="font-medium ml-2 px-3 py-1" removable @remove="removeFilter(filters.district)">
                    {{ getFilterLabel(filters.district) }}
                  </Chip>
                </div>
                
              </div>
              <div class="">
                <div>
                  <template v-if="showBreadcrumbs && $route.query.tag">
                    <Breadcrumb :home="{ icon: 'pi pi-home', to: '/payment_history' }" :model="pageBreadCrumb" />
                  </template>
                  <div class="grid justify-content-start">
                    <!-- Master Page Start -->
                    <div class="col-12">
                      <div class="" :class="{ card: !isSubPage }">
                        <!-- page records template -->
                        <div class="page-records" v-if="!loading">
                          <DataTable :lazy="true" :loading="loading" :value="records" dataKey="payment_history_id"
                            @sort="onSort($event)" class="" :showGridlines="false" :rowHover="true"
                            responsiveLayout="stack">
                            
                            <Column field="customer_id" header="Customer" :sortable="true">
                              <template #body="{ data }">
                                <Button class="p-button-link p-0 text-left" icon="" :label="data.customer_name"
                                  v-if="data.customer_id" @click="
                                    app.navigateTo(
                                      `/customers/view/${data.customer_id}`
                                    )
                                    " />
                              </template>
                            </Column>
                            <Column field="phone_number" header="Telephone" :sortable="true">
                              <template #body="{ data }">
                                {{ data.phone_number }}
                              </template>
                            </Column>
                           
                            <Column field="last_payment_date" header="Last Trans. Date" :sortable="true">
                              <template #body="{ data }">
                                {{ $utils.humanDatetime(data.last_payment_date) || 'No Transaction Available'}}
                              </template>
                            </Column>
                            <Column headerStyle="width: 3em" headerClass="text-center">
                              <template #body="{ data }">
                                <SplitButton class="p-button p-button-raised p-button-text p-button-sm"
                                  :model="getActionMenuModel(data)">
                                  <i></i>
                                </SplitButton>
                              </template>
                            </Column>
                          </DataTable>
                        </div>
                        <!-- page loading indicator -->
                        <template v-if="loading">
                          <div>
                            <DataTable :value="[1, 2, 3, 4, 5, 6, 7, 8, 9]" responsiveLayout="scroll">
                              <Column style="width: 3rem">
                                <template #body>
                                  <Skeleton shape="circle" size="2rem" />
                                </template>
                              </Column>
                              <Column>
                                <template #body>
                                  <Skeleton />
                                </template>
                              </Column>
                              <Column>
                                <template #body>
                                  <Skeleton borderRadius="16px" />
                                </template>
                              </Column>
                              <Column>
                                <template #body>
                                  <Skeleton />
                                </template>
                              </Column>
                              <Column style="width: 3rem">
                                <template #body>
                                  <Skeleton size="2rem" />
                                </template>
                              </Column>
                            </DataTable>
                          </div>
                        </template>
                        <!-- end of page loading indicator-->
                        <!-- Empty record -->
                        <template v-if="pageReady && !records.length">
                          <div class="p-3 my-3 text-500 text-lg font-medium text-center">
                            No record found
                          </div>
                        </template>
                        <!-- end of empty record-->
                        <!-- pagination component-->
                        <template v-if="showFooter">
                          <div class="">
                            <div v-show="pageReady">
                              <div class="flex justify-content-between">
                                <div class="flex justify-content-center flex-grow-0">
                                  <div class="m-2" v-if="exportButton && records.length">
                                    <Button @click="(event) =>
                                      $refs.exportMenu.toggle(event)
                                      " label="" title="Export" icon="pi pi-print" />
                                    <Menu ref="exportMenu" popup :model="pageExportFormats" />
                                  </div>
                                </div>
                                <div v-if="paginate && totalPages > 1" class="flex-grow-1">
                                  <Paginator class="border-none bg-transparent py-3" :first="recordsPosition" @page="(event) => {
                                    pagination.page = event.page + 1;
                                  }
                                    " :rows="pagination.limit" :totalRecords="totalRecords">
                                    <template #start>
                                      <span class="text-sm text-gray-500 px-2">
                                        Records
                                        <b
                                          >{{ recordsPosition }} of
                                          {{ totalRecords }}</b
                                        >
                                      </span> </template>
                                    <template #end>
                                      <Dropdown v-model="pagination.limit" :options="[
                                        5, 10, 15, 20, 30, 40, 50, 100, 200,
                                      ]"></Dropdown>
                                    </template>
                                  </Paginator>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <!-- end of pagination component-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useListPage } from "@/composables/listpage.js";
import { utils } from "@/utils";
import { onMounted, reactive, toRefs } from "vue";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  primaryKey: {
    type: String,
    default: "customer_id",
  },
  pageName: {
    type: String,
    default: "customers",
  },
  routeName: {
    type: String,
    default: "customerslist",
  },
  apiPath: {
    type: String,
    default: "customers/index",
  },
  paginate: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showBreadcrumbs: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  importButton: {
    type: Boolean,
    default: false,
  },
  multiCheckbox: {
    type: Boolean,
    default: false,
  },
  emptyRecordMsg: {
    type: String,
    default: "No record found",
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 10,
  },
  mergeRecords: {
    // for infinite loading
    type: Boolean,
    default: false,
  },
  search: {
    type: String,
    default: "",
  },
  fieldName: null,
  fieldValue: null,
  sortBy: {
    type: String,
    default: "",
  },
  sortType: {
    type: String,
    default: "", //desc or asc
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  filterTagClass: {
    type: String,
    default:
      "surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-center",
  },
});
const app = useApp();
const auth = useAuth();
const filters = reactive({
  // date_created: {
  //   value: "",
  //   valueType: "range-date",
  //   options: [],
  // },
  customer_status: {
    value: "",
    valueType: "single",
    options: [],
  },
  region: {
    value: "",
    valueType: "single",
    options: [],
  },
  district: {
    value: "",
    valueType: "single",
    options: [],
  },
});
//init list page hook
const page = useListPage(props, filters);
//page state
const {
  totalRecords, // total records from api - Number
  recordCount, // current record count - Number
  loading, // Api loading state - Boolean
  selectedItems, // Data table selected items -Array
  pagination, //Pagination object - Object
  searchText, // search text - String
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  records, // page record from store - Array
  apiUrl, // current api path - URL
  currentRecord, // master detail selected record - Object
  pageBreadCrumb, // get page navigation paths - Object
  canLoadMore, // if api has more data for loading - Boolean
  finishedLoading, // if api has finished loading - Boolean
  totalPages, // total number of pages from api - Number
  recordsPosition, // current record position from api - Number
} = page.computedProps;
//page methods
const {
  load, // load data from api
  reload, // reset pagination and load data
  loadNextPage, // load next page
  loadPreviousPage, // load previous page
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  clearSearch, // clear input search
  debounce, // debounce input search
  onSort, // reset page number before sort from api
  deleteItem, // delete item by id or selected items - args = (id) or (selectedItems)
  setCurrentRecord, // master detail set current record
  isCurrentRecord, // master detail
  removeFilter, // remove page filter item - args = (filter.propertyname)
  getFilterLabel, // get filter item display label - args = (filter.propertyname)
  filterHasValue, //check if filter item has value - args = (filter.propertyname)
  importComplete, // reload page after data import
} = page.methods;
const pageExportFormats = [
  {
    label: "Excel",
    icon: "pi pi-file-excel text-green-500",
    command: () => {
      app.exportPageRecords("excel", apiUrl, props.pageName, "xlsx");
    },
  },
];
function getActionMenuModel(data) {
  return [
  {
      label: "View",
      to: `/customers/view/${data.customer_id}`,
      icon: "pi pi-eye",
      visible: auth.canView("customers/view"),
    },
  ];
}
onMounted(() => {
  const pageTitle = "Customers List";
  app.setPageTitle(props.routeName, pageTitle);
  load();
});
</script>
<style scoped></style>
<style scoped></style>
